import React from 'react';
import { InfiniteSlider } from './infinite-slider';
import { Card } from './card';
import { Avatar, AvatarFallback, AvatarImage } from './avatar';
import { Star } from 'lucide-react';

interface Testimonial {
  quote: string;
  author: string;
  company: string;
  avatar: string;
}

interface InfiniteTestimonialSliderProps {
  testimonials: Testimonial[];
  duration?: number;
  durationOnHover?: number;
  className?: string;
}

export function InfiniteTestimonialSlider({
  testimonials,
  duration = 25,
  durationOnHover = 40,
  className
}: InfiniteTestimonialSliderProps) {
  return (
    <div className={className || ''}>
      <InfiniteSlider
        gap={24}
        duration={duration}
        durationOnHover={durationOnHover}
        direction="horizontal"
        className="py-4"
      >
        {testimonials.map((testimonial, index) => (
          <Card 
            key={index}
            className="w-80 h-64 p-8 bg-gradient-card border-0 shadow-elegant hover:scale-105 transition-all duration-300 flex-shrink-0 flex flex-col justify-between"
          >
            {/* Star rating */}
            <div className="flex gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            
            {/* Quote */}
            <blockquote className="text-foreground text-sm leading-relaxed flex-grow">
              "{testimonial.quote}"
            </blockquote>
            
            {/* Author */}
            <div className="flex items-center gap-3 mt-6">
              <Avatar className="h-10 w-10">
                <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                <AvatarFallback className="bg-primary/10 text-primary">
                  {testimonial.author.split(' ').map(n => n[0]).join('')}
                </AvatarFallback>
              </Avatar>
              <div>
                <div className="font-semibold text-foreground text-sm">{testimonial.author}</div>
                <div className="text-muted-foreground text-xs">{testimonial.company}</div>
              </div>
            </div>
          </Card>
        ))}
      </InfiniteSlider>
    </div>
  );
}